import React from 'react';
import { useTranslation } from 'react-i18next';

import { WizardLayout } from '../../components/wizard';
import { useConfigurator } from '../../store/configurator';
import { ColorStyling } from '../design/components/ColorStyling';
import { Status, StatusText, ErrorText } from '../design/design.styles';

/**
 * v0 Step 2 — Colors & Art Style. Choose the brand colour and art style for the theme
 * picked in step 1; the live preview updates from the store selection. Reuses v3's
 * `ColorStyling` (copied under this flow's own folder).
 */
export const ColorsStep = (): React.ReactElement => {
  const { t } = useTranslation();
  const { status } = useConfigurator();

  return (
    <WizardLayout
      currentStep={1}
      title={t('Colors & art style')}
      description={t('Choose your brand colors and pick an art style to give your platform its own look and feel.')}
      nextDisabled={status !== 'ready'}
    >
      {status === 'loading' ? (
        <Status>
          <StatusText text="Loading themes…" tag="span" />
        </Status>
      ) : null}
      {status === 'error' ? (
        <Status>
          <ErrorText text="Couldn’t load the configurator. Please try again." tag="span" />
        </Status>
      ) : null}
      {status === 'ready' ? <ColorStyling /> : null}
    </WizardLayout>
  );
};

export default ColorsStep;
